var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import MuiButton from '@mui/material/Button';
import { useThemeProvider } from '../../utils/useTheme';
var buttonVariants = {
    primary: {
        color: 'blue',
        variant: 'contained',
    },
    secondary: {
        color: 'blue',
        variant: 'outlined',
    },
    tertiary: {
        color: 'red',
        variant: 'contained',
    },
    link: {
        color: 'blue',
        variant: 'text',
    },
};
var isButtonVariant = function (value) {
    return Boolean(value) && typeof value === 'string' && value in buttonVariants;
};
// When the custom theme provider is missing, we cannot use custom props.
var transformButtonVariant = function (isTheme, variant) {
    if (!isTheme)
        return {};
    return isButtonVariant(variant)
        ? buttonVariants[variant]
        : buttonVariants['primary'];
};
/**
 * Pigment [Button](https://pigment.customink.com/?path=/docs/components-button)
 */
export var Button = React.forwardRef(function (_a, ref) {
    var color = _a.color, _b = _a.component, component = _b === void 0 ? 'button' : _b, href = _a.href, variant = _a.variant, forwardableProps = __rest(_a, ["color", "component", "href", "variant"]);
    var isCustomInkProvider = useThemeProvider('customink');
    transformButtonVariant(isCustomInkProvider, variant);
    var isLink = typeof href === 'string';
    return (React.createElement(MuiButton, __assign({ component: isLink ? 'a' : component, href: href, ref: ref }, transformButtonVariant(isCustomInkProvider, variant), forwardableProps)));
});
export default Button;
//# sourceMappingURL=Button.js.map